<template>
  <form-container
    :header="translate('ldapUser.ldapUserProcess')"
    v-on:save="save"
    :disabled="loading"
  >
    <div class="row">
      <form @submit.prevent="validate" :disabled="loading" style="width: 100%">
        <div class="col-12">
          <div class="form-group">
            <label>{{translate('ldapUser.emailList')}}</label>
            <textarea
              v-model="emails"
              type="text"
              class="form-control"
              style="height: 150px"
            ></textarea>
          </div>
          <div class="info">
            <p v-html="translate('ldapUser.info')"></p>
          </div>
          <div class="row" style="margin-top: 20px; margin-right: -26px">
            <div class="col text-right">
              <button
                type="submit"
                class="btn btn-info"
                style="margin-right: 12px"
              >
              {{translate('job.validate')}}
              </button>
            </div>
          </div>
        </div>
      </form>
      <div class="col-12" v-show="exception">
        <h3>{{ exception }}</h3>
        <ul class="list-group">
          <li class="list-group-item" v-for="ex in innerExceptions" :key="ex">
            {{ ex }}
          </li>
        </ul>
      </div>
      <div class="scrollable">
        <table
          class="table table-borderless user-table"
          :class="{ 'table-striped': userList, 'table-hover': userList }"
          v-show="userList.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">{{translate('incomingDoc.username')}}</th>
              <th scope="col">{{translate('job.nameSurname')}}</th>
              <th scope="col">{{translate('externalSigner.email')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in userList" :key="user.UserName">
              <td>{{ user.UserName }}</td>
              <td>{{ user.DisplayName }}</td>
              <td>{{ user.Email }}</td>
            </tr>
          </tbody>
        </table>
        <div
          class="row"
          v-show="userList.length > 0"
          style="margin-top: 20px; margin-right: -26px"
        >
          <div class="col text-right">
            <button
              type="button"
              class="btn btn-success"
              @click="saveLDAPUsers()"
            >
            {{translate('save')}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form-container>
</template>

<script>
import axios from "axios";
import formMixin from "../formMixin.js";
import formContainer from "../components/FormContainer.vue";

export default {
  mixins: [formMixin],
  components: {
    formContainer,
  },
  created() {
    this.data = Object.assign({}, this.model);
  },
  props: {
    value: Object,
    model: Object,
  },
  data() {
    return {
      loading: false,
      userList: [],
      emails: "",
      exception: "",
      innerExceptions: [],
    };
  },
  methods: {
    validate() {
      console.log(this.emails);
      axios
        .post("/LDAP/Check", { Emails: this.emails })
        .then((x) => {
          console.log("POST Result:", x.data);
          if (x.data.Success) {
            this.userList = x.data.ActiveDirectoryUsers;
            this.exception = null;
            this.innerExceptions = [];
          } else {
            this.userList = [];
            this.exception = x.data.Exception;
            this.innerExceptions = x.data.InnerExceptions;
          }
          this.$forceUpdate();
        })
        .catch((x) => {
          this.exception = this.translate('errors.processFailed') + x;
        })
        .then(() => {
          this.loading = false;
        });
    },
    saveLDAPUsers() {
      axios
        .post("/LDAP/AddOrUpdate", { ActiveDirectoryUsers: this.userList })
        .then((x) => {
          if (x.data.Success) {
            setTimeout(() => {
                          this.$router.push({name:'UserList'}); 
            }, 1000);
          } else {
            this.userList = [];
            this.exception = x.data.Exception;
            this.innerExceptions = x.data.InnerExceptions;
            //alert("Kullanıcılar eklenemedi.");
          }
          this.$forceUpdate();
        })
        .catch((x) => {
          this.exception = this.translate('errors.processFailed') + x;
        })
        .then(() => {
          this.loading = false;
        });
    }
  }
};
</script>



<style  scoped>
.scrollable {
  /* overflow-y: scroll;
    overflow-x: hidden;
    max-height: 545px; */
  width: 100%;
  margin-right: 32px;
  margin-top: 20px;
}
.list-group .list-group-item:first-child {
  border-top-right-radius: 0 !important;
  border-top-left-radius: 0 !important;
}
.list-group .list-group-item {
  border-color: #e5e5e5;
  color: #777777;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
}
.list-group {
  padding-left: 0;
  margin-bottom: 20px;
}
.user-table {
  margin-left: 20px;
  margin-right: 20px;
}
.btn-save {
  margin-left: 50%;
  width: 15%;
  border-radius: 12px;
}
.btn-download-template {
  float: right;
  margin-top: -33px;
  border-radius: 12px;
}
.danger {
  background-color: #ffdddd;
  border-left: 6px solid #f44336;
}

.success {
  background-color: #ddffdd;
  border-left: 6px solid #4caf50;
}

.info {
  padding: 20px;
  background-color: #e7f3fe;
  border-left: 6px solid #2196f3;
}

.warning {
  background-color: #ffffcc;
  border-left: 6px solid #ffeb3b;
}
input[type="file"] {
  display: inline-block;
  opacity: 0;
  position: absolute;
  margin-left: 20px;
  margin-right: 20px;
  padding-top: 30px;
  padding-bottom: 67px;
  width: 85%;
  z-index: 99;
  margin-top: 10px;
  cursor: pointer;
}

button {
  padding: 8px;
  border-radius: 3px;
}

button:hover {
  background-color: #2196f3;
  color: white;
}
.button_s {
  width: 78px;
  margin: 5px 10px 5px 5px;
}
.button_m {
  width: 100px;
  margin: 5px 10px 5px 5px;
}
</style>

